import gql from "graphql-tag";
import {client} from "./client";
import {RegisterPerson} from "../../schema/RegisterPerson";

const getRegistrationMutation = (firstName: string, lastName: string, email: string, password: string): any => ({
    mutation: gql`${RegisterPerson}`,
    variables: {
        input: {
            firstName,
            lastName,
            email,
            password,
        },
    },
});

export async function register (email: string, password: string, first_name = 'test', last_name = 'test'):
    Promise<any> {
    const mutation = getRegistrationMutation(first_name, last_name, email, password);
    console.log(mutation);
    await client.mutate(mutation);
}
